import {HTTP_STATUS_OK} from '../../smartpak/httpstatus';
import authentication from '../customeraccount/authentication';
import fetchWalletAccountData from '../shared/fetchwalletaccountdata';
import applePayHelper from './applepayhelper';
import WorldPayActions from './worldpayactions';

export const APPLE_PAY_API_VERSION = 3;

export default function initApplePay(total, onSuccessCallback) {
    const applePayButton = document.getElementById('apple-pay-button');

    if (applePayButton && supportsApplePay()) {
        const beginApplePaySession = createApplePaySession({
            ApplePaySession: window.ApplePaySession,
            asyncMerchantValidation: applePayHelper.performMerchantValidation,
            asyncWorldPayActions: WorldPayActions,
            saveWalletItem: fetchWalletAccountData.saveApplePayWalletItem,
            onSuccess,
            onSuccessCallback
        });

        applePayButton.addEventListener('click', function () {
            beginApplePaySession(total);
        });
    }
}

export function createApplePaySession({
    ApplePaySession,
    asyncMerchantValidation,
    asyncWorldPayActions,
    saveWalletItem,
    onSuccess,
    onSuccessCallback
}) {
    return total => {
        const applePaySession = new ApplePaySession(APPLE_PAY_API_VERSION, {
            countryCode: 'US',
            currencyCode: 'USD',
            supportedNetworks: ['visa', 'masterCard', 'amex', 'discover'],
            merchantCapabilities: ['supports3DS'],
            requiredShippingContactFields: ['name', 'postalAddress', 'email', 'phone'],
            requiredBillingContactFields: ['postalAddress', 'email', 'phone'],
            total
        });

        applePaySession.onvalidatemerchant = async event => {
            const merchantSession = await asyncMerchantValidation(event.validationURL);
            applePaySession.completeMerchantValidation(merchantSession);
        };

        applePaySession.onpaymentauthorized = async event => {
            try {
                const payment = event.payment;
                const walletItem = await asyncWorldPayActions(payment);
                const response = await saveWalletItem(walletItem);

                if (response.status === HTTP_STATUS_OK) {
                    applePaySession.completePayment(applePaySession.STATUS_SUCCESS);
                    onSuccess(response.content.status, payment.shippingContact.emailAddress, onSuccessCallback);
                } else {
                    applePaySession.completePayment(applePaySession.STATUS_FAILURE);
                }
            } catch {
                applePaySession.completePayment(applePaySession.STATUS_FAILURE);
            }
        };

        applePaySession.begin();

        return applePaySession;
    };
}

function supportsApplePay() {
    return applePayHelper.canMakeApplePayments() && applePayHelper.displayApplePay;
}

function onSuccess(accountStatus, emailAddress, onSuccessCallback) {
    const isNewAccount = 0;

    if (typeof onSuccessCallback === 'function') {
        onSuccessCallback();
    }

    if (accountStatus === isNewAccount) {
        handleAuthenticationSuccess();
    } else {
        launchExistingAccountModal(emailAddress);
    }
}

function currentURLIncludes(urlsArray) {
    const currentUrl = window.location.href.toLocaleLowerCase();
    return urlsArray.filter(path => currentUrl.includes(path)).length > 0;
}

function handleAuthenticationSuccess() {
    const urls = ['/cart', '/ps/', '/pt/'];

    if (window.fireBeginCheckoutEvent) {
        window.fireBeginCheckoutEvent('applepay');
    }

    if (currentURLIncludes(urls)) {
        window.location.href = '/checkout/orderreview?cameFromApplePay=True&cameFromRegistration=True';
    } else {
        window.location.reload();
    }
}

function launchExistingAccountModal(emailAddress) {
    let container = document.createElement('div');

    container.append(`We found an account associated with your email, ${emailAddress}`);

    smartPak.ui.modal(container, {
        title: 'Please sign in to check out',
        buttons: {
            'Sign In': function (modal) {
                modal.close();
                authentication._launchModal({
                    success: handleAuthenticationSuccess
                });
            }
        }
    });
}
